import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum OrganizationTypeEnum {
    NONPROFIT = 'nonprofit',
    CONTRIBUTE = 'contribute',
    BUSINESS_ENTITY = 'businessEntity',
}

export const organizationTypeOptions = enumToOptions(OrganizationTypeEnum, 'organization-settings.mado.organizationTypeOptions.');
